import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import {App} from './App';
//import {lightWhite,black} from 'material-ui/styles/colors';
import registerServiceWorker from './registerServiceWorker';
import injectTapEventPlugin from 'react-tap-event-plugin';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import './index.css';
injectTapEventPlugin();

/*const muiTheme = getMuiTheme({
  palette: {
    textColor: black,
  }
});*/

const Root = () => (
  <MuiThemeProvider muiTheme={getMuiTheme(darkBaseTheme)}>
    <App />
  </MuiThemeProvider>
);

 ReactDOM.render((
  <BrowserRouter>
    <Root />
  </BrowserRouter>
), document.getElementById('root'))

registerServiceWorker();
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941


// WEBPACK FOOTER //
// ./src/index.js